import { usePostHog } from "@posthog/react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { authClient } from "@/auth/client";
import { useNotLoggedInRedirect } from "@/hooks/auth";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/log-out")({
  preload: false,
  beforeLoad: async () => {},
  loader: async ({ context: { queryClient, trpc } }) => {
    await authClient.signOut();
    queryClient.removeQueries({
      queryKey: trpc.viewer.get.queryOptions().queryKey,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  const posthog = usePostHog();

  useEffect(() => {
    // Force immediate flush so the event ships with the current
    // distinct_id before reset() clears identity for future events.
    posthog.capture("user_logged_out", undefined, { send_instantly: true });
    posthog.reset();
  }, [posthog]);

  useNotLoggedInRedirect("/log-in");

  return (
    <DefaultLayout classNames={{ content: "min-h-screen" }}>
      {null}
    </DefaultLayout>
  );
}
